// extracted by mini-css-extract-plugin
export default {"progressBarContainer":"LCfRX","progressBar":"KBz8S","goal":"DDZ1A","stretchGoal":"FEUqs","progressInGoal":"ab6zh b7t7P","progressInGoalMatching":"mQuul","roundedCorners":"b7t7P"};